const SpecialAccessReducer = (state = {}, action) => {
  switch (action.type) {
    case "specialAccessDetail":
      return Object.assign({}, state, {
        specialAccessDetail: action.data,
      });
      break;
    case "getSpecialCompanyListSuccess":
      return Object.assign({}, state, {
        specialCompanyList: action.data,
      });
      break;
    
    case "getSpecialCompanyListFailure":
      return Object.assign({}, state, {
        specialCompanyListFailure: action.data,
      });
      break;
      case "getshipByCompanySuccess":
        return Object.assign({}, state, {
          ShipnameList: action.data,
        });
        break;
        case "getshipByCompanyFailure":
          return Object.assign({}, state, {
            ShipnameList: action.data,
          });
          break;
          case "clientId":
            return Object.assign({}, state, {
              clientId: action.data,
            });
            break;
    case "getSpecialClientUsersListSuccess":
      return Object.assign({}, state, {
        specialClientUsersList: action.data,
      });
      break;
    case "getSpecialClientUsersListFailure":
      return Object.assign({}, state, {
        specialClientUsersListFailure: action.data,
      });
      break;
    default: {
      return state;
    }
  }
};
export default SpecialAccessReducer;
